var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _FacetsFormComponent_instances, getSearchQuery_fn, updateURLHash_fn, updateSection_fn, updatePaginationInfo_fn, interceptPaginationLinks_fn, _handleFilterUpdate, _handleKeyUp, _handleFilterUpdate2, _QuickFilterComponent_instances, bindClickHandler_fn, handleCategoryClick_fn, toggleSidebarInput_fn, clearFilterGroup_fn, _handleFilterUpdate3, handleTagClick_fn, buildTagUrl_fn, renderTagFilter_fn, updateTagActiveStates_fn, parseTagsFromUrl_fn, _ResultsTab_instances, bindClickHandler_fn2, fetchCounts_fn, setActiveTab_fn, fetchResults_fn;
import { C as Component, o as onFirstInteractionIdle, d as debounce, i as isMobile, B as isTablet, F as FilterUpdateEvent, s as sectionRenderer, t as lazyReveal, k as CustomEvents } from "./utilities-Da0sjanJ.js";
import { D as DialogOpenEvent } from "./custom-dialog-MTSjyveX.js";
const SEARCH_QUERY = "q";
const SEARCH_TYPE = "type";
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.minRangeInput = this.querySelector(
      ".facet-sidebar-filter-price-slider-handle.min"
    );
    this.maxRangeInput = this.querySelector(
      ".facet-sidebar-filter-price-slider-handle.max"
    );
    this.minPriceInput = this.querySelector(
      'input[name="filter.v.price.gte"]'
    );
    this.maxPriceInput = this.querySelector(
      'input[name="filter.v.price.lte"]'
    );
    this.minPriceInput.addEventListener("focus", this.minPriceInput.select);
    this.maxPriceInput.addEventListener("focus", this.maxPriceInput.select);
    this.minPriceInput.addEventListener(
      "change",
      this.handleInputMinChange.bind(this)
    );
    this.maxPriceInput.addEventListener(
      "change",
      this.handleInputMaxChange.bind(this)
    );
    this.minRangeInput.addEventListener(
      "change",
      this.handleRangeMinChange.bind(this)
    );
    this.maxRangeInput.addEventListener(
      "change",
      this.handleRangeMaxChange.bind(this)
    );
    this.minRangeInput.addEventListener(
      "input",
      this.handleRangeMinInput.bind(this)
    );
    this.maxRangeInput.addEventListener(
      "input",
      this.handleRangeMaxInput.bind(this)
    );
    const handleEnterKey = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        event.target.blur();
      }
    };
    this.minPriceInput.addEventListener("keydown", handleEnterKey);
    this.maxPriceInput.addEventListener("keydown", handleEnterKey);
  }
  handleInputMinChange(event) {
    event.stopPropagation();
    let val = parseInt(event.target.value);
    if (isNaN(val) || val < 0) val = 0;
    const maxLimit = parseInt(this.maxPriceInput.value || event.target.max);
    if (!isNaN(maxLimit) && val >= maxLimit) {
      val = maxLimit - 1;
    }
    event.target.value = val;
    this.minRangeInput.value = val;
    const pct = val / parseInt(this.minRangeInput.max) * 95;
    this.minRangeInput.parentElement.style.setProperty(
      "--range-min",
      `${pct}%`
    );
    const facetsForm = this.closest("facets-form-component");
    if (facetsForm instanceof FacetsFormComponent) {
      facetsForm.updateFilters();
    }
  }
  handleInputMaxChange(event) {
    event.stopPropagation();
    let val = parseInt(event.target.value);
    const absoluteMax = parseInt(event.target.max);
    if (isNaN(val) || val > absoluteMax) val = absoluteMax;
    const minLimit = parseInt(this.minPriceInput.value || event.target.min || 0);
    if (!isNaN(minLimit) && val <= minLimit) {
      val = minLimit + 1;
    }
    event.target.value = val;
    this.maxRangeInput.value = val;
    this.maxRangeInput.parentElement.style.setProperty(
      "--range-max",
      `${val / parseInt(this.maxRangeInput.max) * 100}%`
    );
    const facetsForm = this.closest("facets-form-component");
    if (facetsForm instanceof FacetsFormComponent) {
      facetsForm.updateFilters();
    }
  }
  handleRangeMinChange(event) {
    event.stopPropagation();
    this.minPriceInput.value = event.target.value;
    this.minPriceInput.dispatchEvent(
      new Event("change", { bubbles: true })
    );
  }
  handleRangeMaxChange(event) {
    event.stopPropagation();
    this.maxPriceInput.value = event.target.value;
    this.maxPriceInput.dispatchEvent(
      new Event("change", { bubbles: true })
    );
  }
  handleRangeMinInput(event) {
    const max = parseInt(event.target.max);
    const maxVal = parseInt(this.maxPriceInput.value || max);
    event.target.value = Math.min(parseInt(event.target.value), maxVal - 1);
    const pct = parseInt(event.target.value) / max * 98;
    event.target.parentElement.style.setProperty(
      "--range-min",
      `${pct}%`
    );
    this.minPriceInput.value = event.target.value;
  }
  handleRangeMaxInput(event) {
    const minVal = parseInt(this.minPriceInput.value || event.target.min || 0);
    event.target.value = Math.max(parseInt(event.target.value), minVal + 1);
    const max = parseInt(event.target.max);
    event.target.parentElement.style.setProperty(
      "--range-max",
      `${parseInt(event.target.value) / max * 100}%`
    );
    this.maxPriceInput.value = event.target.value;
  }
}
customElements.define("price-range", PriceRange);
class SortingDropdown extends Component {
  constructor() {
    super();
    this.el = this;
    this.trigger = this.el.querySelector(".collection-sort-head");
    this.dropdown = this.el.querySelector(".collection-sort-drop");
    this.itemList = this.el.querySelectorAll(
      ".collection-sort-drop-item-link"
    );
    this.form = this.closest("facets-form-component").querySelector("form");
  }
  connectedCallback() {
    super.connectedCallback();
    this.init();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.handleClickOutside) {
      document.removeEventListener("click", this.handleClickOutside);
    }
    if (this.handleFocusOut) {
      this.el.removeEventListener("focusout", this.handleFocusOut);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  static closeAllDropdowns() {
    const allDropdowns = document.querySelectorAll(
      "sorting-component .collection-sort-drop.active"
    );
    allDropdowns.forEach((dropdown) => {
      dropdown.classList.remove("active");
    });
  }
  init() {
    if (this.trigger && this.dropdown) {
      this.trigger.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isCurrentlyActive = this.dropdown.classList.contains("active");
        SortingDropdown.closeAllDropdowns();
        if (!isCurrentlyActive) {
          this.dropdown.classList.add("active");
          const activeItem = this.el.querySelector('.collection-sort-drop-item[tabindex="0"]');
          if (activeItem) {
            setTimeout(() => activeItem.focus(), 50);
          }
        }
      });
      this.handleClickOutside = (e) => {
        if (!this.el.contains(e.target)) {
          this.dropdown.classList.remove("active");
        }
      };
      this.handleFocusOut = (e) => {
        if (!this.el.contains(e.relatedTarget)) {
          this.dropdown.classList.remove("active");
        }
      };
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            if (this.dropdown.classList.contains("active")) {
              document.addEventListener(
                "click",
                this.handleClickOutside
              );
              this.el.addEventListener(
                "focusout",
                this.handleFocusOut
              );
            } else {
              document.removeEventListener(
                "click",
                this.handleClickOutside
              );
              this.el.removeEventListener(
                "focusout",
                this.handleFocusOut
              );
            }
          }
        });
      });
      this.observer.observe(this.dropdown, { attributes: true });
    }
  }
  handleKeyDown(event) {
    var _a;
    const { key } = event;
    if (!this.dropdown.classList.contains("active") || key !== "ArrowDown" && key !== "ArrowUp" && key !== "Enter" && key !== " " && key !== "Escape") {
      return;
    }
    event.preventDefault();
    if (key === "Escape") {
      this.dropdown.classList.remove("active");
      (_a = this.trigger) == null ? void 0 : _a.focus();
      return;
    }
    const items = this.dropItems || (this.dropItems = Array.from(this.el.querySelectorAll(".collection-sort-drop-item")));
    const currentIndex = items.indexOf(document.activeElement);
    if (currentIndex === -1) return;
    if (key === "Enter" || key === " ") {
      const input = items[currentIndex].querySelector("input");
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
      return;
    }
    const isNext = key === "ArrowDown";
    const step = isNext ? 1 : -1;
    const nextIndex = (currentIndex + step + items.length) % items.length;
    items[currentIndex].setAttribute("tabindex", "-1");
    items[nextIndex].setAttribute("tabindex", "0");
    items[nextIndex].focus();
  }
  updateFilterAndSorting(event) {
    var _a;
    this.dropdown.classList.remove("active");
    const input = event.srcElement;
    if (input.getAttribute("data-option-name") === this.refs.currentSortBy.textContent)
      return;
    this.itemList.forEach(
      (el) => el.closest(".collection-sort-drop-item-link").classList.remove("active")
    );
    input.closest(".collection-sort-drop-item-link").classList.add("active");
    const { currentSortBy } = this.refs;
    currentSortBy.textContent = input.getAttribute("data-option-name");
    const facetsForm = this.closest("facets-form-component") || ((_a = this.closest(".shopify-section")) == null ? void 0 : _a.querySelector(
      "facets-form-component"
    ));
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFilters();
  }
}
if (!customElements.get("sorting-component")) {
  customElements.define("sorting-component", SortingDropdown);
}
class FacetsFormComponent extends Component {
  constructor() {
    super();
    __privateAdd(this, _FacetsFormComponent_instances);
    __publicField(this, "requiredRefs", ["facetsForm"]);
    /** Updates filters and renders the section **/
    __publicField(this, "updateFilters", async () => {
      var _a;
      const active = document.activeElement;
      const focusSelector = (active == null ? void 0 : active.id) ? `#${CSS.escape(active.id)}` : (active == null ? void 0 : active.name) ? `${active.tagName}[name="${active.name}"][value="${active.value || ""}"]` : null;
      __privateMethod(this, _FacetsFormComponent_instances, updateURLHash_fn).call(this);
      this.dispatchEvent(new FilterUpdateEvent(this.createURLParameters()));
      await __privateMethod(this, _FacetsFormComponent_instances, updateSection_fn).call(this);
      if (focusSelector) {
        (_a = this.querySelector(focusSelector)) == null ? void 0 : _a.focus({ preventScroll: true });
      }
    });
    this.filterSidebar = this.querySelector(".filter-sidebar");
    this.sidebarWidth = null;
  }
  connectedCallback() {
    super.connectedCallback();
    const desktopLayout = this.getAttribute("data-desktop-filter-layout");
    const isDialogComponent = this.classList.contains("facets-form-component-dialog");
    if (desktopLayout !== "drawer" && !isDialogComponent) {
      const updateSidebarWidth = () => {
        const sidebar = this.querySelector(".facet-sidebar");
        if (!sidebar) return;
        const width = sidebar.getBoundingClientRect().width;
        if (width > 0) {
          this.sidebarWidth = width;
          sidebar.style.setProperty("--sidebar-width", `${width}px`);
        } else {
          sidebar.style.removeProperty("--sidebar-width");
        }
      };
      onFirstInteractionIdle(updateSidebarWidth);
      window.addEventListener("resize", debounce(updateSidebarWidth, 200));
    }
    __privateMethod(this, _FacetsFormComponent_instances, updatePaginationInfo_fn).call(this);
    __privateMethod(this, _FacetsFormComponent_instances, interceptPaginationLinks_fn).call(this);
  }
  handleFilterToggle(data, e) {
    e.preventDefault();
    e.stopPropagation();
    const filterToggleButton = e.target.closest(".filter-toggle") || e.target;
    const desktopLayout = this.getAttribute("data-desktop-filter-layout");
    if (isMobile() || isTablet() || desktopLayout === "drawer") {
      const dialog = document.querySelector(`${data.targetDialog}`);
      if (!dialog || dialog.open) {
        return;
      }
      dialog.showDialog();
      this.dispatchEvent(new DialogOpenEvent());
    } else {
      filterToggleButton.classList.toggle("active");
      this.setAttribute(
        "data-filter",
        filterToggleButton.classList.contains("active") ? "open" : "close"
      );
    }
  }
  get sectionId() {
    const id = this.getAttribute("section-id");
    if (!id) throw new Error("Section ID is required");
    return id;
  }
  get filterSortingDialog() {
    return document.querySelector("custom-dialog#filterSortingDialog");
  }
  get resultsListComponent() {
    return this.closest(".shopify-section").querySelector("results-list");
  }
  /**
   * Creates URL parameters from form data
   * @param {FormData} [formData] - Optional form data to use instead of the main form
   * @returns {URLSearchParams} The processed URL parameters
   */
  createURLParameters(formData = new FormData(this.refs.facetsForm)) {
    let newParameters = new URLSearchParams(formData);
    if (newParameters.get("filter.v.price.gte") === "")
      newParameters.delete("filter.v.price.gte");
    if (newParameters.get("filter.v.price.lte") === "")
      newParameters.delete("filter.v.price.lte");
    newParameters.delete("page");
    const defaultSortBy = this.getAttribute("data-default-sort-by");
    if (defaultSortBy && newParameters.get("sort_by") === defaultSortBy) {
      newParameters.delete("sort_by");
    }
    const searchQuery = __privateMethod(this, _FacetsFormComponent_instances, getSearchQuery_fn).call(this);
    if (searchQuery) newParameters.set(SEARCH_QUERY, searchQuery);
    const searchType = new URL(window.location.href).searchParams.get(SEARCH_TYPE);
    if (searchType) newParameters.set(SEARCH_TYPE, searchType);
    return newParameters;
  }
  /**
   * Updates filters based on a provided URL
   * @param {string} url - The URL to update filters with
   * @param {boolean} focusFirstProduct - Whether to focus the first product after update
   */
  updateFiltersByURL(url, focusFirstProduct = false) {
    history.pushState("", "", url);
    const urlParams = new URLSearchParams(
      new URL(url, window.location.origin).search
    );
    this.dispatchEvent(new FilterUpdateEvent(urlParams));
    __privateMethod(this, _FacetsFormComponent_instances, updateSection_fn).call(this, focusFirstProduct);
    __privateMethod(this, _FacetsFormComponent_instances, updatePaginationInfo_fn).call(this);
  }
}
_FacetsFormComponent_instances = new WeakSet();
/**
 * Gets the search query parameter from the current URL
 * @returns {string} The search query
 */
getSearchQuery_fn = function() {
  const url = new URL(window.location.href);
  return url.searchParams.get(SEARCH_QUERY) ?? "";
};
/** Updates the URL hash with current filter parameters **/
updateURLHash_fn = function() {
  const url = new URL(window.location.href);
  const urlParameters = this.createURLParameters();
  url.search = "";
  for (const [param, value] of urlParameters.entries()) {
    url.searchParams.append(param, value);
  }
  history.pushState(
    { urlParameters: urlParameters.toString() },
    "",
    url.toString()
  );
};
updateSection_fn = async function(focusFirstProduct = false) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const productListEl = this.closest(".shopify-section").querySelector(".product-list");
  productListEl == null ? void 0 : productListEl.classList.add("anim-fade-out");
  if (!((_a = this.filterSortingDialog) == null ? void 0 : _a.open) && this.resultsListComponent) {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) || 0;
    const resultsTop = this.resultsListComponent.getBoundingClientRect().top;
    if (resultsTop < headerHeight) {
      this.resultsListComponent.scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth"
      });
    }
  }
  (_c = (_b = this.resultsListComponent) == null ? void 0 : _b.querySelector(".paginate-info")) == null ? void 0 : _c.classList.add("anim-fade-out");
  await sectionRenderer.renderSection(this.sectionId);
  lazyReveal(this.resultsListComponent);
  __privateMethod(this, _FacetsFormComponent_instances, updatePaginationInfo_fn).call(this);
  productListEl == null ? void 0 : productListEl.classList.remove("anim-fade-out");
  productListEl == null ? void 0 : productListEl.classList.add("anim-fade-in");
  (_e = (_d = this.resultsListComponent) == null ? void 0 : _d.querySelector(".paginate-info")) == null ? void 0 : _e.classList.remove("anim-fade-out");
  (_g = (_f = this.resultsListComponent) == null ? void 0 : _f.querySelector(".paginate-info")) == null ? void 0 : _g.classList.add("anim-fade-in");
  if (focusFirstProduct) {
    const firstProductLink = (_h = this.resultsListComponent) == null ? void 0 : _h.querySelector(".product-list a[href]:not([tabindex='-1']), .article-card a[href]:not([tabindex='-1']), .page-card a[href]:not([tabindex='-1'])");
    if (firstProductLink) {
      firstProductLink.focus({ preventScroll: true });
    }
  }
};
updatePaginationInfo_fn = function() {
  var _a;
  const sectionEl = this.closest(".shopify-section");
  const pagiEnd = (_a = this.resultsListComponent) == null ? void 0 : _a.querySelector("[data-pagi-end] .text-custom-content-inner");
  const pagiSource = sectionEl == null ? void 0 : sectionEl.querySelector("[data-pagi-source]");
  if (pagiEnd && pagiSource) {
    pagiEnd.innerHTML = pagiSource.getAttribute("data-pagi-source");
  }
};
/**
 * Intercept pagination link clicks within the collection page
 * and route them through updateFiltersByURL for AJAX rendering
 */
interceptPaginationLinks_fn = function() {
  const resultsListEl = this.resultsListComponent;
  if (!resultsListEl) return;
  resultsListEl.addEventListener(
    "click",
    (e) => {
      const link = e.target.closest(".js-pagination-link");
      if (!link) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const url = link.href || link.getAttribute("href");
      if (!url) return;
      this.updateFiltersByURL(url, true);
    },
    true
  );
};
if (!customElements.get("facets-form-component")) {
  customElements.define("facets-form-component", FacetsFormComponent);
}
class FacetInputsComponent extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "prefetchPage", debounce((event) => {
      if (!(event.target instanceof HTMLElement)) return;
      const form = this.closest("form");
      if (!form) return;
      const formData = new FormData(form);
      const inputElement = event.target.querySelector("input");
      if (!(inputElement instanceof HTMLInputElement)) return;
      if (!inputElement.checked)
        formData.append(inputElement.name, inputElement.value);
      const facetsForm = this.closest("facets-form-component");
      if (!(facetsForm instanceof FacetsFormComponent)) return;
      const urlParameters = facetsForm.createURLParameters(formData);
      const url = new URL(window.location.pathname, window.location.origin);
      for (const [key, value] of urlParameters)
        url.searchParams.append(key, value);
      if (inputElement.checked)
        url.searchParams.delete(inputElement.name, inputElement.value);
      sectionRenderer.getSectionHTML(this.sectionId, true, url);
    }, 200));
    __publicField(this, "cancelPrefetchPage", () => this.prefetchPage.cancel());
  }
  updateFilters() {
    const facetsForm = this.closest("facets-form-component");
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFilters();
  }
  handleKeyDown(event) {
    const input = document.activeElement;
    if (!(input instanceof HTMLInputElement) || !this.contains(input)) return;
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      input.checked = !input.checked;
      this.updateFilters();
      return;
    }
    if (["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(event.key)) {
      if (input.type !== "checkbox" && input.type !== "radio") return;
      event.preventDefault();
      const inputs = Array.from(this.querySelectorAll('input:not([disabled])[type="radio"], input:not([disabled])[type="checkbox"]'));
      if (inputs.length === 0) return;
      const currentIndex = inputs.indexOf(input);
      if (currentIndex === -1) return;
      const forward = event.key === "ArrowDown" || event.key === "ArrowRight";
      const nextIndex = (currentIndex + (forward ? 1 : -1) + inputs.length) % inputs.length;
      inputs[nextIndex].focus();
    }
  }
  get sectionId() {
    var _a;
    const id = (_a = this.closest(".shopify-section")) == null ? void 0 : _a.id;
    if (!id)
      throw new Error(
        "FacetInputs component must be a child of a section"
      );
    return id;
  }
}
if (!customElements.get("facet-inputs-component")) {
  customElements.define("facet-inputs-component", FacetInputsComponent);
}
class FacetRemoveComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _handleFilterUpdate, (event) => {
      const { removeAllButton } = this.refs;
      if (removeAllButton instanceof Element) {
        removeAllButton.classList.toggle(
          "hidden",
          !event.shouldShowClearAll()
        );
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(
      CustomEvents.FilterUpdate,
      __privateGet(this, _handleFilterUpdate)
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      CustomEvents.FilterUpdate,
      __privateGet(this, _handleFilterUpdate)
    );
  }
  removeFilter({ form }, event) {
    if (event instanceof KeyboardEvent) {
      if (event.key !== "Enter" && event.key !== " ") {
        return;
      }
      event.preventDefault();
    }
    const url = this.dataset.url;
    if (!url) return;
    const facetsForm = form ? document.getElementById(form) : this.closest("facets-form-component");
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFiltersByURL(url);
  }
}
_handleFilterUpdate = new WeakMap();
if (!customElements.get("facet-remove-component")) {
  customElements.define("facet-remove-component", FacetRemoveComponent);
}
class FacetClearComponent extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "requiredRefs", ["clearButton"]);
    /**
     * Handles keyup events
     * @param {KeyboardEvent} event - The keyup event
     */
    __privateAdd(this, _handleKeyUp, (event) => {
      if (event.metaKey) return;
      if (event.key === "Enter") this.clearFilter(event);
    });
    /**
     * Toggle clear button visibility when filters are applied. Happens before the
     * Section Rendering Request resolves.
     *
     * @param {FilterUpdateEvent} event
     */
    __privateAdd(this, _handleFilterUpdate2, (event) => {
      const { clearButton } = this.refs;
      if (clearButton instanceof Element) {
        clearButton.classList.toggle(
          "facets__clear--active",
          event.shouldShowClearAll()
        );
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("keyup", __privateGet(this, _handleKeyUp));
    document.addEventListener(
      CustomEvents.FilterUpdate,
      __privateGet(this, _handleFilterUpdate2)
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      CustomEvents.FilterUpdate,
      __privateGet(this, _handleFilterUpdate2)
    );
  }
  /**
   * Clears the filter
   * @param {Event} event - The click event
   */
  clearFilter(event) {
    if (!(event.target instanceof HTMLElement)) return;
    if (event instanceof KeyboardEvent) {
      if (event.key !== "Enter" && event.key !== " ") {
        return;
      }
      event.preventDefault();
    }
    const container = event.target.closest("facets-form-component").querySelector(this.dataset.target);
    container == null ? void 0 : container.querySelectorAll('[type="checkbox"]:checked, input').forEach((input) => {
      if (input instanceof HTMLInputElement && (input.value === this.dataset.value || input.type === "range" || input.type === "number")) {
        input.checked = false;
        input.value = "";
      }
    });
    const facetsForm = this.closest("facets-form-component");
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFilters();
    this.remove();
  }
}
_handleKeyUp = new WeakMap();
_handleFilterUpdate2 = new WeakMap();
if (!customElements.get("facet-clear-component")) {
  customElements.define("facet-clear-component", FacetClearComponent);
}
class FacetPaginationComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
  }
  /**
   * Handle updatePage calls from on:click="/updatePage" buttons (legacy pattern)
   */
  updatePage(data, event) {
    event.preventDefault();
    const url = data.url;
    if (!url) return;
    const facetsForm = this.closest(".shopify-section").querySelector(
      "facets-form-component"
    );
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFiltersByURL(url, true);
  }
}
if (!customElements.get("facet-pagination-component")) {
  customElements.define(
    "facet-pagination-component",
    FacetPaginationComponent
  );
}
class QuickFilterComponent extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _QuickFilterComponent_instances);
    __privateAdd(this, _handleFilterUpdate3, (event) => {
      var _a;
      const params = (_a = event.detail) == null ? void 0 : _a.queryParams;
      if (!params) return;
      this.querySelectorAll(".quick-filter-btn-content-inner").forEach(
        (el) => el.classList.remove("active")
      );
      const buttons = this.querySelectorAll(".quick-filter-btn-label");
      let hasActiveFilter = false;
      buttons.forEach((btn) => {
        var _a2, _b;
        const name = btn.dataset.name;
        const value = btn.dataset.value;
        if (!value) return;
        const activeValues = params.getAll(name);
        if (activeValues.includes(value)) {
          (_b = (_a2 = btn.closest(".quick-filter-btn-content")) == null ? void 0 : _a2.querySelector(".quick-filter-btn-content-inner")) == null ? void 0 : _b.classList.add("active");
          hasActiveFilter = true;
        }
      });
      if (!hasActiveFilter) {
        const allBtn = this.querySelector(
          "[data-quick-filter-all] .quick-filter-btn-content-inner"
        );
        if (allBtn) {
          allBtn.classList.add("active");
        }
      }
    });
  }
  connectedCallback() {
    this.facetsForm = document.querySelector("facets-form-component");
    this.filterType = this.dataset.filterType;
    this.collectionUrl = this.dataset.collectionUrl;
    __privateMethod(this, _QuickFilterComponent_instances, bindClickHandler_fn).call(this);
    if (this.filterType === "category") {
      this._boundFilterUpdate = __privateGet(this, _handleFilterUpdate3).bind(this);
      document.addEventListener(
        CustomEvents.FilterUpdate,
        this._boundFilterUpdate
      );
    }
  }
  disconnectedCallback() {
    if (this._boundFilterUpdate) {
      document.removeEventListener(
        CustomEvents.FilterUpdate,
        this._boundFilterUpdate
      );
    }
  }
}
_QuickFilterComponent_instances = new WeakSet();
/**
 * Handle quick filter button clicks.
 * Category type: toggle sidebar form inputs.
 * Tag type: build tag URL and AJAX render.
 */
bindClickHandler_fn = function() {
  this.addEventListener("click", (e) => {
    const btn = e.target.closest(".quick-filter-btn-label");
    if (!btn) return;
    e.preventDefault();
    if (this.filterType === "tag") {
      __privateMethod(this, _QuickFilterComponent_instances, handleTagClick_fn).call(this, btn);
    } else {
      __privateMethod(this, _QuickFilterComponent_instances, handleCategoryClick_fn).call(this, btn);
    }
  });
};
// ─── Category filter handlers (existing logic) ───
handleCategoryClick_fn = function(btn) {
  const paramName = btn.dataset.name;
  const paramValue = btn.dataset.value;
  if (!this.facetsForm) return;
  const form = this.facetsForm.querySelector("form");
  if (!form) return;
  if (!paramValue) {
    __privateMethod(this, _QuickFilterComponent_instances, clearFilterGroup_fn).call(this, form, paramName);
  } else {
    __privateMethod(this, _QuickFilterComponent_instances, toggleSidebarInput_fn).call(this, form, paramName, paramValue);
  }
};
toggleSidebarInput_fn = function(form, name, value) {
  const selector = `input[name="${name}"][value="${value.replace(/"/g, '\\"')}"]`;
  const input = form.querySelector(selector);
  if (input) {
    input.checked = !input.checked;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }
};
clearFilterGroup_fn = function(form, name) {
  const inputs = form.querySelectorAll(`input[name="${name}"]:checked`);
  if (inputs.length === 0) return;
  inputs.forEach((input) => {
    input.checked = false;
  });
  inputs[0].dispatchEvent(new Event("change", { bubbles: true }));
};
_handleFilterUpdate3 = new WeakMap();
// ─── Tag filter handlers (new AJAX logic) ───
/**
 * Handle tag button click:
 * Compute the new tag URL dynamically from the current URL,
 * then navigate via pushState + AJAX section render.
 */
handleTagClick_fn = function(btn) {
  const tagHandle = btn.dataset.tagHandle;
  if (!tagHandle) return;
  const activeTags = __privateMethod(this, _QuickFilterComponent_instances, parseTagsFromUrl_fn).call(this, window.location.href);
  const tagIndex = activeTags.indexOf(tagHandle);
  if (tagIndex > -1) {
    activeTags.splice(tagIndex, 1);
  } else {
    activeTags.push(tagHandle);
  }
  const tagUrl = __privateMethod(this, _QuickFilterComponent_instances, buildTagUrl_fn).call(this, activeTags);
  __privateMethod(this, _QuickFilterComponent_instances, updateTagActiveStates_fn).call(this, tagUrl);
  __privateMethod(this, _QuickFilterComponent_instances, renderTagFilter_fn).call(this, tagUrl);
};
/**
 * Build a collection tag URL from an array of tag handles.
 * @param {string[]} tags - Array of tag handles
 * @returns {string} URL like /collections/handle/tag1+tag2
 */
buildTagUrl_fn = function(tags) {
  const base = this.collectionUrl || window.location.pathname;
  if (tags.length === 0) return base;
  return `${base}/${tags.join("+")}`;
};
renderTagFilter_fn = async function(url) {
  const facetsFormEl = this.facetsForm || document.querySelector("facets-form-component");
  if (!facetsFormEl) return;
  const sectionEl = facetsFormEl.closest(".shopify-section");
  if (!sectionEl) return;
  const sectionId = facetsFormEl.getAttribute("section-id") || sectionEl.id;
  const productListEl = sectionEl.querySelector(".product-list");
  const resultsListEl = sectionEl.querySelector("results-list");
  const paginateInfo = resultsListEl == null ? void 0 : resultsListEl.querySelector(".paginate-info");
  productListEl == null ? void 0 : productListEl.classList.add("anim-fade-out");
  paginateInfo == null ? void 0 : paginateInfo.classList.add("anim-fade-out");
  resultsListEl == null ? void 0 : resultsListEl.scrollIntoView({
    block: "start",
    inline: "nearest",
    behavior: "smooth"
  });
  history.pushState({ tagFilter: true }, "", url);
  await sectionRenderer.renderSection(sectionId);
  lazyReveal(sectionEl);
  const newResultsList = sectionEl.querySelector("results-list");
  const pagiEnd = newResultsList == null ? void 0 : newResultsList.querySelector("[data-pagi-end] .text-custom-content-inner");
  const pagiSource = sectionEl == null ? void 0 : sectionEl.querySelector("[data-pagi-source]");
  if (pagiEnd && pagiSource) {
    pagiEnd.innerHTML = pagiSource.getAttribute("data-pagi-source");
  }
  const newProductList = sectionEl.querySelector(".product-list");
  newProductList == null ? void 0 : newProductList.classList.remove("anim-fade-out");
  newProductList == null ? void 0 : newProductList.classList.add("anim-fade-in");
  const newPaginateInfo = newResultsList == null ? void 0 : newResultsList.querySelector(".paginate-info");
  newPaginateInfo == null ? void 0 : newPaginateInfo.classList.remove("anim-fade-out");
  newPaginateInfo == null ? void 0 : newPaginateInfo.classList.add("anim-fade-in");
};
/**
 * Update active states on tag buttons based on the target URL.
 */
updateTagActiveStates_fn = function(targetUrl) {
  const activeTags = __privateMethod(this, _QuickFilterComponent_instances, parseTagsFromUrl_fn).call(this, targetUrl);
  this.querySelectorAll(".quick-filter-btn-content-inner").forEach(
    (el) => el.classList.remove("active")
  );
  const buttons = this.querySelectorAll(
    ".quick-filter-btn-label[data-tag-handle]"
  );
  let hasActiveFilter = false;
  buttons.forEach((btn) => {
    var _a, _b;
    const tagHandle = btn.dataset.tagHandle;
    if (activeTags.includes(tagHandle)) {
      (_b = (_a = btn.closest(".quick-filter-btn-content")) == null ? void 0 : _a.querySelector(".quick-filter-btn-content-inner")) == null ? void 0 : _b.classList.add("active");
      hasActiveFilter = true;
    }
  });
  if (!hasActiveFilter) {
    const allBtn = this.querySelector(
      "[data-quick-filter-all] .quick-filter-btn-content-inner"
    );
    if (allBtn) {
      allBtn.classList.add("active");
    }
  }
};
/**
 * Parse tag handles from a URL path.
 * URL format: /collections/{handle}/{tag1+tag2}
 * @param {string} url - The URL to parse
 * @returns {string[]} Array of tag handles
 */
parseTagsFromUrl_fn = function(url) {
  try {
    const pathname = new URL(url, window.location.origin).pathname;
    const collectionUrl = this.collectionUrl;
    if (!collectionUrl) return [];
    const tagsPart = pathname.replace(collectionUrl, "").replace(/^\//, "");
    if (!tagsPart) return [];
    return tagsPart.split("+").filter(Boolean);
  } catch {
    return [];
  }
};
if (!customElements.get("quick-filter")) {
  customElements.define("quick-filter", QuickFilterComponent);
}
class ResultsTab extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ResultsTab_instances);
  }
  connectedCallback() {
    __privateMethod(this, _ResultsTab_instances, bindClickHandler_fn2).call(this);
    __privateMethod(this, _ResultsTab_instances, fetchCounts_fn).call(this);
  }
}
_ResultsTab_instances = new WeakSet();
bindClickHandler_fn2 = function() {
  this.addEventListener("click", (e) => {
    const tab = e.target.closest("[data-tab-type]");
    if (!tab) return;
    e.preventDefault();
    const link = tab.querySelector("a[data-filter-type]");
    const url = (link == null ? void 0 : link.href) || (link == null ? void 0 : link.getAttribute("href"));
    if (!url) return;
    __privateMethod(this, _ResultsTab_instances, setActiveTab_fn).call(this, tab);
    __privateMethod(this, _ResultsTab_instances, fetchResults_fn).call(this, url);
  });
};
fetchCounts_fn = async function() {
  var _a, _b, _c;
  const searchTerm = this.dataset.searchTerm;
  if (!searchTerm) return;
  const types = ["product", "article", "page"];
  const searchUrl = Theme.routes.search_url || "/search";
  try {
    const results = await Promise.all(
      types.map(async (type) => {
        const url = `${searchUrl}?q=${encodeURIComponent(searchTerm)}&type=${type}&sections=search-type-count`;
        const res = await fetch(url);
        const data = await res.json();
        const html = data["search-type-count"] || "";
        const count = parseInt(html.replace(/<[^>]*>/g, "").trim(), 10) || 0;
        return { type, count };
      })
    );
    for (const { type, count } of results) {
      const sup = this.querySelector(`sup[data-type="${type}"]`);
      const tabContent = this.querySelector(`[data-tab-type="${type}"]`);
      const prevDivider = tabContent == null ? void 0 : tabContent.previousElementSibling;
      if (count === 0) {
        if (tabContent) tabContent.style.display = "none";
        if (prevDivider == null ? void 0 : prevDivider.classList.contains("result-tabs-btn-divider")) {
          prevDivider.style.display = "none";
        }
      } else {
        if (sup) sup.textContent = count;
        const activeTabType = (_c = (_b = (_a = this.querySelector(".result-tabs-btn-content-inner.active")) == null ? void 0 : _a.closest("[data-tab-type]")) == null ? void 0 : _b.dataset) == null ? void 0 : _c.tabType;
        if (activeTabType === type) {
          const mainCountEl = document.querySelector(".sc-page-heading-title-count");
          if (mainCountEl) mainCountEl.textContent = count;
        }
      }
    }
    this.style.display = "";
  } catch (error) {
  }
};
/**
 * Update active tab styling
 */
setActiveTab_fn = function(clickedBtn) {
  var _a, _b, _c, _d;
  this.querySelectorAll(".result-tabs-btn-content-inner").forEach(
    (el) => el.classList.remove("active")
  );
  const tabInner = (_a = clickedBtn.closest(".result-tabs-btn-content")) == null ? void 0 : _a.querySelector(".result-tabs-btn-content-inner");
  if (tabInner) {
    tabInner.classList.add("active");
  }
  const tabType = ((_b = clickedBtn.dataset) == null ? void 0 : _b.tabType) || ((_d = (_c = clickedBtn.closest("[data-tab-type]")) == null ? void 0 : _c.dataset) == null ? void 0 : _d.tabType);
  if (tabType) {
    const sup = this.querySelector(`sup[data-type="${tabType}"]`);
    const mainCountEl = document.querySelector(".sc-page-heading-title-count");
    if (sup && mainCountEl) {
      mainCountEl.textContent = sup.textContent;
    }
  }
};
fetchResults_fn = async function(url) {
  const facetsForm = document.querySelector("facets-form-component");
  if (facetsForm instanceof FacetsFormComponent) {
    facetsForm.updateFiltersByURL(url, true);
    return;
  }
  window.location.href = url;
};
if (!customElements.get("results-tab")) {
  customElements.define("results-tab", ResultsTab);
}
